import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Header from "./components/layout/Header";
import Footer from "./components/Footer";
import StickyCTAs from "./components/StickyCTAs";

import Home from "./pages/Home";
import OurCraft from "./pages/OurCraft";
import Products from "./pages/Products";
import ProductCategoryPage from "./pages/ProductCategoryPage";
import CustomOrders from "./pages/CustomOrders";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Sitemap from "./pages/Sitemap";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/"              element={<Home />} />
          <Route path="/our-craft"     element={<OurCraft />} />
          <Route path="/products"           element={<Products />} />
          <Route path="/products/:slug"    element={<ProductCategoryPage />} />
          <Route path="/custom-orders"     element={<CustomOrders />} />
          <Route path="/projects"          element={<Projects />} />
          <Route path="/about"             element={<About />} />
          <Route path="/contact"           element={<Contact />} />
          <Route path="/thank-you"         element={<ThankYou />} />
          <Route path="/terms"             element={<Terms />} />
          <Route path="/privacy"           element={<Privacy />} />
          <Route path="/sitemap"           element={<Sitemap />} />
          <Route path="*"                  element={<NotFound />} />
        </Routes>
        <Footer />
        <StickyCTAs />
      </BrowserRouter>
    </div>
  );
}

export default App;
